/* cf-colour-change-double.js - Click Fencing, 2026-08-18
 *
 * Changing the fence colour after a quote has calculated DOUBLES the quote. Flat top and
 * PerfMesh only; blade is unaffected.
 *
 * MEASURED, on the live site, clean page load, one colour click and nothing else:
 *
 *   flat top   1 section  9000mm         $687.96   -> $1,375.92
 *   PerfMesh   1 section  9000mm       $2,015.52   -> $4,031.04
 *   PerfMesh   2 sections 6000+6000    $2,717.76   -> $5,435.52
 *
 * Every line appears twice. It is exactly double, never cumulative - a second colour
 * click re-doubles from the clean figure rather than tripling. The doubled breakdown is
 * what "Add to Cart", "Download Quote PDF" and "Email Quote" all read, so it is not a
 * display artefact: the customer is charged twice the fence.
 *
 * The exposure is an ordinary path through the form - set your length, then change your
 * mind about the colour, then add to cart. Nothing warns anybody.
 *
 * THE HEAL
 * --------
 * Any subsequent length edit rebuilds the breakdown cleanly, and one nudge on ONE section
 * rebuilds ALL of them - verified above on the 2-section case. So this patch does what a
 * customer accidentally does: after a colour change it re-enters a section length, using
 * the calculator's own recalculation path. Nothing is parsed, nothing is patched
 * downstream, and the output is the calculator's own clean quote.
 *
 * Re-dispatching the SAME value does nothing - the handler ignores an unchanged value -
 * so the nudge has to go to a different number and come back. The customer's number is
 * restored exactly, as the original string.
 *
 * WHY IT NUDGES UNCONDITIONALLY RATHER THAN DETECTING THE DUPLICATION
 * ------------------------------------------------------------------
 * Duplicate detection is not safe here. A legitimate multi-section quote repeats the same
 * SKU, quantity and price across sections - a 2-section mesh quote has two identical kit
 * lines when it is perfectly correct - so counting repeated lines produces false
 * positives. The nudge is idempotent: run against a quote that is already clean it
 * reproduces the same figures (verified), so doing it every time costs one recalculation
 * and cannot be wrong.
 *
 * The instances are closed over and unreachable (see the calculator skill's reachability
 * map), which is why this works through the form rather than the solver.
 *
 * NOT FIXED HERE: the underlying accumulator in flat-top.js / perfmesh-calc.js that
 * appends the rebuilt section instead of replacing it. That needs a source edit.
 */
(function () {
  'use strict';
  if (window.__cfColourDoubleInstalled) return;
  window.__cfColourDoubleInstalled = true;

  /* Only the two calculators where the doubling is confirmed. Blade recalculates cleanly
     on a colour change and must not be given a spurious extra recalculation. */
  if (!/flat-top|perfmesh/i.test(location.pathname)) return;

  var SETTLE_MS = 1400;   /* let the calculator's own colour rebuild finish first */
  var STEP_MS   = 700;    /* between the two halves of the nudge */
  var busy = false;
  var pending = null;

  /* The first section whose length the customer has actually filled in. Nudging an empty
     input would push the calculator into a state the customer never asked for. */
  function firstLength() {
    var inputs = document.querySelectorAll('input[id^="section-"][id$="-length"]');
    for (var i = 0; i < inputs.length; i++) {
      var v = String(inputs[i].value || '').trim();
      if (v && /^\d+$/.test(v) && Number(v) > 0) return inputs[i];
    }
    return null;
  }

  function fire(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function heal() {
    var el = firstLength();
    if (!el) { busy = false; return; }

    var original = String(el.value);          /* restore the exact string, not a number */
    var probe = String(Number(original) + 1);

    try {
      el.value = probe;
      fire(el);
    } catch (e) { busy = false; return; }

    setTimeout(function () {
      try {
        el.value = original;
        fire(el);
        console.log('[cf-colour-change-double] rebuilt quote after colour change');
      } catch (e) {}
      busy = false;
    }, STEP_MS);
  }

  function schedule() {
    if (busy) return;
    busy = true;
    clearTimeout(pending);
    pending = setTimeout(function () {
      try { heal(); } catch (e) { busy = false; }
    }, SETTLE_MS);
  }

  document.addEventListener('change', function (e) {
    var n = e && e.target;
    if (!n || n.name !== 'shared-color') return;
    schedule();
  }, true);

  /* The colour control is a set of styled radios; some skins fire click without change. */
  document.addEventListener('click', function (e) {
    var n = e && e.target;
    if (!n || !n.closest) return;
    var lbl = n.closest('label');
    if (!lbl) return;
    if (lbl.querySelector('input[name="shared-color"]')) schedule();
  }, true);

  console.log('[cf-colour-change-double] installed');
})();
